const FePartCategories = () => import("Application/modules/configuration/fe_part_categories/views/FePartCategories");
const FePartCategoriesForm = () => import("Application/modules/configuration/fe_part_categories/views/FePartCategoriesForm");

export default {
    children: [
        {
            path: "fe_part_categories",
            name: "fe_part_categories",
            component: FePartCategories,
            meta: {
                requiresAuth: true,
                title: "lang.fe_part_categories",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["fe_parts.read"],
            },
        },
        {
            path: "fe_part_category/:id?",
            name: "fe_part_category",
            component: FePartCategoriesForm,
            meta: {
                requiresAuth: true,
                title: "lang.fe_part_categories",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["fe_parts.read"],
            },
        },
    ],
};
